var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_3753)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M221 193L181.688 208L52.0625 216L-55.25 259H1166.62L1129.44 216H1020L983.875 178L618.375 187L463.25 155L403.75 187L361.25 178L306 201L221 193Z",
  fill: "white",
  stroke: "#B5D7E3"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M482.375 173L380.375 216L275.188 178L102 264L1166.62 259L1208.06 178L1105 155L983.875 178L946.688 142L881.875 155L776.688 90L671.5 155L551.438 120L482.375 173Z",
  fill: "white",
  stroke: "#B5D7E3"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M552.5 200L489.812 211L430.312 218L347.438 259H1166.62L1296.25 104L1152.81 58L1025.31 111L946.688 142L851.062 120L756.5 155L707.625 120L637.5 142L552.5 200Z",
  fill: "white",
  stroke: "#B5D7E3"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.85,
  d: "M817.062 142L700.188 235L670.438 229L627.938 259H1375.94L1369.56 1L1320.69 50L1246.31 20L1154.94 96L1099.69 83L1009.38 160L933.938 96L853.188 155L817.062 142Z",
  fill: "white",
  stroke: "#B5D7E3"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_3753"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1360,
  height: 248,
  fill: "white"
})));
function SvgGhostMountains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 248,
    viewBox: "0 0 1360 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostMountains);
export default __webpack_public_path__ + "static/media/ghost-mountains.219b54eaa8059e04e92fd6e51d88e23f.svg";
export { ForwardRef as ReactComponent };